import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { GeneralSetting } from '@apis/index'

interface SeoData {
  metaTitle?: string
  title?: string
  description?: string
  [key: string]: any
}

export const useSeoData = (id: string, stateKey: string): SeoData => {
  const { data } = useSelector((state: any) => state[stateKey])
  useEffect(() => {
    if (!data?.id) {
      GeneralSetting.getByKey({ id, state: stateKey }).catch(() => {})
    }
  }, [id, stateKey])

  let parsedData = {}
  try {
    parsedData = data?.value ? JSON.parse(data.value) : {}
  } catch (error) {
    console.error('Invalid JSON in SEO data:', error)
  }

  return parsedData
}
